import styled from '@emotion/styled';
import { Box } from '@mui/material';
import BackgroundImage from '../../assets/background.svg';

export const SpinnerWrapper = styled(Box)`
  background-color: white;
  z-index: 3;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;

  :before {
    background: url(${BackgroundImage}) no-repeat center center;
    background-size: cover;
    top: 0;
    left: 0;
    position: fixed;
    content: '';
    width: 100%;
    height: 100%;
    z-index: -1;
    will-change: transform;
  }
`;

export const ModalSpinnerWrapper = styled(Box)`
  width: 100%;
  display: flex;
  justify-content: center;
  > span {
    position: absolute;
    top: 50%;
  `;
